<template>
  <div class="autocomplete-field">
    <b-autocomplete
      :open-on-focus="openOnFocus"
      :placeholder="placeholder"
      :data="filteredDataObj"
      :field="field"
      @select="option => selected = option"
      @input="handleChange"
      v-model="model"
    ></b-autocomplete>
    <label class="label-auto">{{label}}</label>
  </div>
</template>

<script>
import { removeUnicodeCharacters } from "@/plugins/utils"

export default {
  data() {
    return {
      selected: null,
      value: "",
      model: this.initValue ? `${this.initValue}` : null
    };
  },
  props: {
    initValue: {
      type: String
    },
    field: {
      type: String,
      default: "name"
    },
    placeholder: {
      type: String
    },
    openOnFocus: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    valueOfField: {
      type: String
    }
  },
  computed: {
    filteredDataObj() {
      return this.data.filter(option => {
        const field = option[this.field] || option
        const value = this.model && this.model.toLowerCase()
        if (!value) return true

        const cleanedField = removeUnicodeCharacters(field, field.length)
        return field
              .toString()
              .toLowerCase()
              .indexOf(value) >= 0 
              || cleanedField
              .toString()
              .toLowerCase()
              .indexOf(value) >= 0
      });
    }
  },
  methods: {
    handleChange() {
      this.$emit("onChange", this.selected);
    }
  },
  watch: {
    initValue (value) {
      this.model = value
    }
  },
};
</script>
<style lang="scss" >
.autocomplete-field {
  position: relative;

  label {
    position: absolute;
    top: 0;
    left: 0;
    padding: 5px 12px;
    color: #7a8189;
    transition: 0.2s all;
    font-size: 10px;
  }
  .control {
    input {
      height: 46px;
      border: none;
      background: #f2f2f2;
      outline: none;
      box-shadow: none;
      padding: 12px 0 0 12px;
      font-size: 14px;

      // &:hover {
      //   box-shadow: none;

      //   label {
      //     top: 0 !important;
      //     font-size: 10px;
      //   }
      // }
    }
  }
}
</style>